import {ChatBotService} from "../../../core/services/services/chat-bot.service";
import {Subject} from "rxjs";
import {employeeDataModel} from "../employee-data/employeeData.model";
import * as pako from "pako";
import { Injectable, OnDestroy } from "@angular/core";

@Injectable()
export class MessageHandler implements OnDestroy {
	public messageSubject: Subject<{output: string; type: string; data?: any}> = new Subject<{output: string; type: string; data?: any}>();

	constructor(private chatBotService: ChatBotService) {}

	public employeeData: employeeDataModel = {
		positions: [
			{
				title: "",
				description: "",
				requestedQuantity: 0,
				requestedSkills: [],
				matchingEmployees: [],
			},
		],
	};

	openConnection() {
		this.chatBotService.backendMessageSubject.subscribe((message) => {
			try {
				// Dekomprimiere Daten falls sie komprimiert sind
				const decompressed = this.decompressMessage(message);
				const messageParsed: any = JSON.parse(decompressed);
				let messageType: string = messageParsed.dataType || "DEFAULT";
				
				if (messageParsed.info) {
					messageType = "INFO";
				}

				switch (messageType) {
					case "DEFAULT":
					case "EMPLOYEE": {
						const llmResponse = messageParsed.llmResponse;
						this.messageSubject.next({
							output: messageParsed.output,
							type: "MESSAGE",
							data: llmResponse ? { llmResponse } : undefined
						});
						break;
					}

					case "INQUIRY": {
						this.employeeData = messageParsed.data;
						const inquiryOutput = messageParsed.conclusion || messageParsed.output;
						const llmResponse = messageParsed.llmResponse;
						// Emit llmResponse as a separate property, not merged into employeeDataModel
						this.messageSubject.next({
							output: inquiryOutput,
							type: "MESSAGE",
							data: { employeeData: this.employeeData, llmResponse }
						});
						break;
					}

					case "REQUIREMENT": {
						if (messageParsed.data) {
							this.employeeData.positions = [messageParsed.data];
						}
						const requirementOutput = messageParsed.conclusion || messageParsed.output;
						const llmResponse = messageParsed.llmResponse;
						this.messageSubject.next({
							output: requirementOutput,
							type: "MESSAGE",
							data: { employeeData: this.employeeData, llmResponse }
						});
						break;
					}

					case "INFO":
						this.messageSubject.next({
							output: messageParsed.info, 
							type: "INFO"
						});
						break;

					case "ERROR":
					case "NOEMPLOYEE":
						this.messageSubject.next({
							output: messageParsed.output, 
							type: "ERROR"
						});
						break;

					default:
						console.warn(`Unknown message type: ${messageType}`);
						break;
				}
			} catch (error) {
				console.error('Error parsing message:', error);
				this.messageSubject.next({
					output: "Fehler beim Verarbeiten der Antwort",
					type: "ERROR"
				});
			}
		});
	}

	/**
	 * Dekomprimiere Nachrichten falls sie mit GZIP komprimiert wurden
	 */
	private decompressMessage(message: string): string {
		try {
			const parsed = JSON.parse(message);
			
			if (parsed._compressed && parsed._data) {
				const binaryString = atob(parsed._data);
				const bytes = new Uint8Array(binaryString.length);
				
				for (let i = 0; i < binaryString.length; i++) {
					bytes[i] = binaryString.charCodeAt(i);
				}
				
				const decompressed = this.gunzip(bytes);
				const result = new TextDecoder().decode(decompressed);
				return result;
			}
			
			return message;
		} catch (error) {
			console.error('Error decompressing message:', error);
			return message;
		}
	}

	/**
	 * GZIP Dekompression mit pako library
	 */
	private gunzip(compressed: Uint8Array): Uint8Array {

		
		if (!pako) {
			console.error('pako library not loaded.');
			throw new Error('GZIP decompression library not available');
		}
		
		return pako.ungzip(compressed);
	}

	ngOnDestroy() {
    this.chatBotService.stopPolling();
}
}